'use es6';

import get from 'transmute/get';

/**
 * @deprecated use `inboxGetters` instead
 */
export const getInboxId = get('id');